var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.drawer,
            title:
              _vm.$t("goodsPage.package.Name") +
              " : " +
              _vm.form.giftRules.skuName,
            direction: "rtl",
            size: "600px",
            "modal-append-to-body": false,
            "before-close": _vm.onCancel,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _vm.form
            ? _c("BjDivider", [
                _vm._v(_vm._s(_vm.$t("goodsPage.package.bindSKU"))),
              ])
            : _vm._e(),
          _vm.drawer
            ? _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    disabled: _vm.disabled,
                    "label-width": "200px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsPage.package.Method") + ":",
                        prop: "packingMethod",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          placeholder: _vm.$t("goodsPage.package.Method"),
                          "option-list": _vm.MethodOption,
                        },
                        on: { change: _vm.changeList },
                        model: {
                          value: _vm.form.packingMethod,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "packingMethod", $$v)
                          },
                          expression: "form.packingMethod",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SelectSKUText") + ":" } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "main-btn",
                          attrs: { type: "primary" },
                          on: { click: _vm.choseSKU },
                        },
                        [_vm._v(_vm._s(_vm.$t("SelectSKUText")))]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticStyle: { "margin-top": "10px" } },
                    [
                      _c("BjDivider", [
                        _vm._v(
                          _vm._s(_vm.$t("AddInternalRefundOnlyDoc.Product"))
                        ),
                      ]),
                      _c(
                        "el-table",
                        {
                          ref: "multipleTable",
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.form.mainSkuList,
                            "max-height": "460px",
                            border: "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              type: "index",
                              label: _vm.$t("billingPage.index"),
                              align: "center",
                              width: "60",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "skuName",
                              label: _vm.$t("goodsPage.skuName"),
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "skuCode",
                              label: _vm.$t("goodsPage.skuCode"),
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "barCode",
                              label: _vm.$t("goodsSku.detail.Barcode"),
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "action",
                              label: _vm.$t("operationText"),
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onDelete(
                                                scope.row,
                                                scope.$index
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("delText")))]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1629097879
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "foot",
                      staticStyle: { "margin-top": "60px" },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "danger" },
                          on: { click: _vm.onCancel },
                        },
                        [_vm._v(_vm._s(_vm.$t("cancelText")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.form.mainSkuList.length == 0,
                            type: "primary",
                          },
                          on: { click: _vm.onComfirm },
                        },
                        [_vm._v(_vm._s(_vm.$t("okText")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c("BjDialogList", {
        ref: "dialogList",
        attrs: {
          multiple: "",
          config: _vm.$BjDialogListConfig.skuDefault("SelectSKUText", {
            defaultQuery: _vm.defaultQuery,
            columns: _vm.columns,
            search: _vm.search,
            actionApi: _vm.actionApi,
          }),
        },
        on: { confirm: _vm.onAddDialogConfirm },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("goodsPage.package.bindInfo"),
            visible: _vm.dialogShow,
            width: "500px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogShow = $event
            },
          },
        },
        [
          _c("div", { staticClass: "flex-align" }, [
            _c("div", { staticStyle: { "font-weight": "bold" } }, [
              _c("div", { staticStyle: { "margin-top": "8px" } }, [
                _vm._v(
                  _vm._s(_vm.$t("goodsPage.package.Method")) +
                    " : " +
                    _vm._s(
                      _vm.$t(
                        _vm.MethodOption.bjGet(_vm.dialogData.packingMethod)
                      )
                    )
                ),
              ]),
              _c("div", { staticStyle: { "margin-top": "8px" } }, [
                _vm._v(
                  _vm._s(_vm.$t("goodsPage.package.Name")) +
                    " : " +
                    _vm._s(_vm.dialogData.packageName)
                ),
              ]),
              _c("div", { staticStyle: { "margin-top": "8px" } }, [
                _vm._v(
                  _vm._s(_vm.$t("goodsPage.skuName")) +
                    " : " +
                    _vm._s(_vm.dialogData.skuNames)
                ),
              ]),
            ]),
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogShow = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("cancelText")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.goBind()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("goodsPage.package.bindSKU")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }